export const performance = globalThis.performance;
